import Link from 'next/link';
import React, { FC } from 'react';
import { IoLinkOutline, IoShareOutline } from 'react-icons/io5';

import { ActionIcon, Group, Tooltip } from '@mantine/core';
import { CollectionHelpers } from 'src/helpers/CollectionHelpers';

import { SavedItemType } from 'models';

import { SaveButton } from 'components/buttons/SaveButton';
import { useCopyShareUrl } from 'hooks/use-copy-share-url';
import { InternalTrackingService } from 'services/InternalTrackingService';

import { useComponentContext } from '../hooks/use-component-context';

import cx from './ComponentDatasheetActions.Public.module.scss';

const ComponentDatasheetActionsPublic: FC = () => {
    const { component } = useComponentContext();
    const { clipboard, share } = useCopyShareUrl('product');

    return (
        <Group gap="xs" wrap="nowrap">
            {component.id && (
                <SaveButton
                    id={component.id}
                    name={component.name}
                    type={SavedItemType.COMPONENT}
                    company={CollectionHelpers.id(component.manufacturer)}
                    iconOnly
                    actionIconProps={{ className: cx.circle }}
                />
            )}

            <Tooltip label={clipboard.copied ? 'Copied url' : 'Share'}>
                <ActionIcon
                    variant="white"
                    size="lg"
                    radius={99}
                    className={cx.circle}
                    onClick={share}
                    aria-label="Share product"
                >
                    <IoShareOutline size={16} />
                </ActionIcon>
            </Tooltip>

            {component.website && (
                <Tooltip label="Visit the website">
                    <ActionIcon
                        component={Link}
                        href={component.website}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Visit the website"
                        variant="white"
                        size="lg"
                        radius={99}
                        className={cx.circle}
                        {...InternalTrackingService.link('product.website', 'Visit the website')}
                    >
                        <IoLinkOutline size={16} />
                    </ActionIcon>
                </Tooltip>
            )}
        </Group>
    );
};

export { ComponentDatasheetActionsPublic };
